import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3461c556"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pretitle" }, "Kurz vorgestellt", -1))
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "actions"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "There is no Infotext related this object.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_side_menu = _resolveComponent("side-menu")!
  const _component_ion_alert = _resolveComponent("ion-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_content, {
      "scroll-events": true,
      onIonScroll: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onContentScroll($event)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { class: "ion-padding" }, {
          default: _withCtx(() => [
            (_ctx.isReady)
              ? (_openBlock(), _createBlock(_component_ion_row, {
                  key: 0,
                  class: "ion-justify-content-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      class: "close-btn",
                      fill: "clear",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCloseAlertOpen(true)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.closeOutline,
                          size: "large",
                          color: "dark"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }),
                    (_ctx.infotext)
                      ? (_openBlock(), _createBlock(_component_ion_col, {
                          key: 0,
                          "size-xs": "12",
                          "size-sm": "12",
                          "size-md": "12",
                          "size-lg": "8",
                          class: _normalizeClass(["infotext-view", {'last-slide': !!_ctx.showTaggingButton}])
                        }, {
                          default: _withCtx(() => [
                            _hoisted_1,
                            _createElementVNode("h3", {
                              innerHTML: _ctx.infotext.title
                            }, null, 8, _hoisted_2),
                            _createVNode(_component_swiper, {
                              modules: _ctx.modules,
                              a11y: true,
                              keyboard: true,
                              pagination: true,
                              navigation: true,
                              zoom: true,
                              autoHeight: true,
                              onReachEnd: _ctx.swiperReachEnd,
                              onChange: _ctx.setShowScrollArrow
                            }, {
                              default: _withCtx(() => [
                                (_ctx.infotext.card2)
                                  ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "infos",
                                          innerHTML: _ctx.fixHTML(_ctx.infotext.card2)
                                        }, null, 8, _hoisted_3)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.infotext.card3)
                                  ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "infos",
                                          innerHTML: _ctx.fixHTML(_ctx.infotext.card3)
                                        }, null, 8, _hoisted_4)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.infotext.card4)
                                  ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 2 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "infos",
                                          innerHTML: _ctx.fixHTML(_ctx.infotext.card4)
                                        }, null, 8, _hoisted_5)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.infotext.card5)
                                  ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 3 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "infos",
                                          innerHTML: _ctx.fixHTML(_ctx.infotext.card5)
                                        }, null, 8, _hoisted_6)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.infotext.card6)
                                  ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 4 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "infos",
                                          innerHTML: _ctx.fixHTML(_ctx.infotext.card6)
                                        }, null, 8, _hoisted_7)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.infotext.card7)
                                  ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 5 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "infos",
                                          innerHTML: _ctx.fixHTML(_ctx.infotext.card7)
                                        }, null, 8, _hoisted_8)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.infotext.card8)
                                  ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 6 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "infos",
                                          innerHTML: _ctx.fixHTML(_ctx.infotext.card8)
                                        }, null, 8, _hoisted_9)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.infotext.card9)
                                  ? (_openBlock(), _createBlock(_component_swiper_slide, { key: 7 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "infos",
                                          innerHTML: _ctx.fixHTML(_ctx.infotext.card9)
                                        }, null, 8, _hoisted_10)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["modules", "onReachEnd", "onChange"]),
                            (_ctx.showTaggingButton)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createVNode(_component_ion_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_col, {
                                        "size-xs": "12",
                                        "size-sm": "12",
                                        "size-md": "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_button, {
                                            expand: "block",
                                            color: "thing-tag",
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToLongText()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('message.moreInfo')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_col, {
                                        "size-xs": "12",
                                        "size-sm": "12",
                                        "size-md": "6",
                                        "size-lg": "6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_button, {
                                            expand: "block",
                                            color: "thing-tag",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dismiss()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('message.gotagging')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.showScrollArrow)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "scroll-arrow-container",
                                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.scrollDown && _ctx.scrollDown(...args)))
                                }, [
                                  _createVNode(_component_ion_icon, {
                                    class: "scroll-down-arrow",
                                    icon: _ctx.chevronDown
                                  }, null, 8, ["icon"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : (_openBlock(), _createBlock(_component_ion_col, {
                          key: 1,
                          size: "12",
                          "size-xs": "12",
                          "size-sm": "12",
                          "size-md": "12",
                          "size-lg": "6"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.showTaggingButton)
      ? (_openBlock(), _createBlock(_component_side_menu, {
          key: 0,
          onOnMoreInfo: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToLongText())),
          showDismiss: true,
          showMoreInfo: true
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_alert, {
      "is-open": _ctx.isCloseAlertOpen,
      header: "Schließen!",
      message: "Möchtest Du wirklich nicht weiter zum Taggen?",
      buttons: _ctx.alertButtons,
      onDidDismiss: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setCloseAlertOpen(false)))
    }, null, 8, ["is-open", "buttons"])
  ], 64))
}